var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.43,76.64,239,66.11l-3.23-2a3,3,0,0,1-1.37-2.78,14.24,14.24,0,0,0,.06-1.85A3,3,0,0,1,236,56.82l3.34-1.8L233.45,44.1l-3.34,1.79a2.93,2.93,0,0,1-3.08-.2,17,17,0,0,0-1.57-1,3,3,0,0,1-1.56-2.67l.12-3.8-12.38-.38-.12,3.8a2.94,2.94,0,0,1-1.72,2.57c-.28.13-.55.26-.82.41s-.53.29-.79.45a2.94,2.94,0,0,1-3.08,0l-3.25-2-6.53,10.53,3.23,2a3,3,0,0,1,1.37,2.77,14.24,14.24,0,0,0-.06,1.85,3,3,0,0,1-1.54,2.67L195,64.73l5.85,10.92,3.35-1.79a2.93,2.93,0,0,1,3.07.2c.51.35,1,.67,1.57,1a2.94,2.94,0,0,1,1.56,2.67l-.12,3.8,12.39.39.12-3.81a2.91,2.91,0,0,1,1.72-2.55c.27-.13.55-.27.82-.42s.53-.29.79-.45a3,3,0,0,1,3.1,0ZM222,68.82a10.15,10.15,0,1,1,4.15-13.74A10.14,10.14,0,0,1,222,68.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29,212.37,65.81,208l-1.33-2.3a2.07,2.07,0,0,1,.08-2.17c.23-.36.45-.73.65-1.12A2,2,0,0,1,67,201.3H69.7v-8.69H67a2,2,0,0,1-1.83-1.14c-.2-.39-.42-.76-.65-1.12a2.07,2.07,0,0,1-.08-2.17l1.33-2.3-7.52-4.34L57,183.85a2.06,2.06,0,0,1-1.91,1c-.21,0-.43,0-.64,0s-.43,0-.64,0a2.07,2.07,0,0,1-1.91-1l-1.34-2.32L43,185.88l1.34,2.31a2.05,2.05,0,0,1-.08,2.16,12.53,12.53,0,0,0-.65,1.12,2,2,0,0,1-1.83,1.14H39.12v8.69h2.66a2,2,0,0,1,1.83,1.14,12.53,12.53,0,0,0,.65,1.12,2.05,2.05,0,0,1,.08,2.16L43,208l7.52,4.34,1.34-2.31a2.05,2.05,0,0,1,1.91-1l.64,0,.64,0a2.05,2.05,0,0,1,1.91,1Zm-3.88-8.3A7.12,7.12,0,1,1,61.52,197,7.11,7.11,0,0,1,54.41,204.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.09,86l-4.34-7.52-2.3,1.33a2.05,2.05,0,0,1-2.16-.07,11.42,11.42,0,0,0-1.13-.65A2.06,2.06,0,0,1,274,77.22V74.56h-8.68v2.66a2,2,0,0,1-1.15,1.83,12.53,12.53,0,0,0-1.12.65,2.05,2.05,0,0,1-2.16.07l-2.3-1.33L254.27,86l2.31,1.33a2.07,2.07,0,0,1,1,1.92c0,.21,0,.42,0,.64s0,.43,0,.64a2,2,0,0,1-1,1.9l-2.31,1.34,4.34,7.52,2.3-1.33a2.07,2.07,0,0,1,2.17.08c.36.23.73.45,1.12.65a2.06,2.06,0,0,1,1.14,1.83v2.66H274v-2.66a2.06,2.06,0,0,1,1.14-1.83c.39-.2.76-.42,1.12-.65a2.05,2.05,0,0,1,2.16-.08l2.31,1.33,4.34-7.52-2.31-1.33a2.06,2.06,0,0,1-1-1.91c0-.21,0-.43,0-.64s0-.43,0-.64a2.07,2.07,0,0,1,1-1.92Zm-8.3,3.89a7.11,7.11,0,1,1-7.11-7.12A7.11,7.11,0,0,1,276.79,89.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,327.51l-13.35.28-6.58.11c-2.19.05-4.36,0-6.55.06l.45-.45.05,11.19-.5-.5,13.24.06c4.42,0,8.83.12,13.24.17l-.27.27c0-1.83.09-3.67.13-5.54Zm0,0,.15,5.54c0,1.86.11,3.75.13,5.65V339H451c-4.41,0-8.82.16-13.24.17l-13.24.06h-.5v-.5l.06-11.19v-.45h.44c2.24,0,4.47,0,6.7.05l6.66.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.73,
    y: 237.59,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.44,223.48l-13.35.27-6.58.12c-2.19,0-4.37,0-6.55,0l.45-.44,0,11.18-.5-.49,13.24.06c4.42,0,8.83.11,13.24.16l-.27.27c0-1.83.09-3.67.13-5.53Zm0,0,.14,5.53c.05,1.87.12,3.76.14,5.65v.27h-.28c-4.41.05-8.82.16-13.24.16l-13.24.06h-.5v-.51l.06-11.18V223H276c2.23,0,4.47,0,6.7.05l6.66.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,223.48l-13.36.27-6.58.12c-2.19,0-4.36,0-6.54,0l.44-.44.06,11.18-.5-.49,13.24.06c4.41,0,8.82.11,13.24.16l-.28.27c0-1.83.09-3.67.13-5.53Zm0,0,.14,5.53c0,1.87.11,3.76.13,5.65v.27H332c-4.42.05-8.83.16-13.24.16l-13.24.06H305v-.51l.05-11.18V223h.45c2.23,0,4.46,0,6.69.05l6.66.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.73,59.94l13.35-.27,6.58-.12c2.19,0,4.37,0,6.55,0l-.45.44-.05-11.19.5.5L77,49.19c-4.42,0-8.83-.11-13.24-.16l.27-.28c0,1.84-.09,3.68-.13,5.54Zm0,0-.15-5.53c0-1.87-.11-3.76-.13-5.66v-.27h.28c4.41,0,8.82-.16,13.24-.16l13.24-.07h.5v.5l-.06,11.19v.45h-.44c-2.23,0-4.47,0-6.7-.06l-6.66-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.96,
    y: 62.86,
    width: 26.48,
    height: 11.19,
    transform: "translate(124.39 136.92) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.56,60l13.36-.28,6.58-.11c2.19,0,4.36,0,6.54-.06l-.44.45-.05-11.19.49.5L437.8,49.2c-4.41,0-8.82-.11-13.24-.16l.28-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.14-5.54c0-1.87-.11-3.76-.13-5.65V48.5h.27c4.42-.05,8.83-.16,13.24-.16L451,48.27h.51v.51L451.49,60v.45H451c-2.23,0-4.46,0-6.69,0l-6.66-.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.1,
    y: 388.47,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.44,331.69,62.08,332l-6.58.11c-2.19.05-4.36,0-6.54.06l.44-.45.05,11.19-.49-.5,13.24.06c4.41,0,8.82.12,13.24.17l-.28.27c0-1.83.09-3.67.13-5.54Zm0,0,.14,5.54c0,1.86.11,3.75.13,5.65v.27h-.27c-4.42.05-8.83.16-13.24.17L49,343.38h-.51v-.5l0-11.19v-.45H49c2.23,0,4.46,0,6.69.06l6.66.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.81,374.36l-13.36.28-6.58.11c-2.18.05-4.36,0-6.54.06l.44-.45.06,11.19-.5-.5,13.24.07c4.41,0,8.83.11,13.24.16l-.27.27c0-1.83.08-3.67.13-5.53Zm0,0,.14,5.54c.05,1.87.11,3.75.13,5.65v.27h-.27c-4.41.05-8.83.15-13.24.16l-13.24.06h-.5v-.5l0-11.19v-.45h.45c2.23,0,4.47,0,6.69.05l6.66.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.06,277.49v151h91.29v-151Zm83,95.29H337.35V333.46h74.71Zm0-48.68H337.35V284.79h74.71Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.36,
    y: 277.5,
    width: 41.28,
    height: 151.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.35,
    y: 284.79,
    width: 17.75,
    height: 39.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.32,419.28H337.57v-38h74.75Zm-74.25-.5h73.75v-37H338.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.57,
    y: 392.09,
    width: 14.75,
    height: 5.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.35,
    y: 333.47,
    width: 17.75,
    height: 39.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.48,
    y: 348.41,
    width: 36.24,
    height: 12.49,
    transform: "translate(750.25 -40.95) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.69,
    y: 356.8,
    width: 7.82,
    height: 12.49,
    transform: "translate(758.65 -32.55) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.28,
    y: 344.28,
    width: 4.64,
    height: 12.49,
    transform: "translate(746.12 -45.08) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.14,
    y: 293.77,
    width: 31.57,
    height: 30.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.7,
    y: 293.77,
    width: 12,
    height: 30.33,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.14 308.94 390.7 308.94 366.05 309.72 359.14 308.94",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.7 320.44 359.14 320.44 383.79 321.22 390.7 320.44",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.14 300.46 379.13 300.46 361.36 301.1 359.14 300.46",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.7 315.97 370.71 315.97 388.48 316.61 390.7 315.97",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.71 297.08 389.26 297.08 385.5 297.46 366.71 297.08",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.21 312.19 384.76 312.19 381 312.57 362.21 312.19",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.07 303.35 390.7 303.35 393.32 304.37 376.07 303.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.11 303.35 369.74 303.35 372.35 304.37 355.11 303.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.88 316.98 359.25 316.98 356.64 318 373.88 316.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.7 313.52 402.45 313.52 405.06 314.54 390.7 313.52",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.8 308.94 403.91 308.94 402.7 308.1 394.8 308.94",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.85,
    y: 334.11,
    width: 10.22,
    height: 38.66,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,341.74a2.13,2.13,0,1,1,2.12-2.13A2.13,2.13,0,0,1,407,341.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,340.83a1.22,1.22,0,1,1,1.21-1.22A1.22,1.22,0,0,1,407,340.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.25,
    y: 356.87,
    width: 9.41,
    height: 10.22,
    transform: "translate(768.94 -44.97) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.69,
    y: 364.79,
    width: 38.66,
    height: 8.04,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.73,368.81a2.13,2.13,0,1,1,2.13,2.13A2.12,2.12,0,0,1,381.73,368.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.64,368.81a1.22,1.22,0,1,1,1.22,1.22A1.21,1.21,0,0,1,382.64,368.81Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.78,
    y: 364.79,
    width: 9.41,
    height: 8.04,
    transform: "translate(722.97 737.63) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 407.27,
    cy: 204.94,
    rx: 47.1,
    ry: 46.38,
    transform: "translate(79.9 522.28) rotate(-70.82)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 407.27,
    cy: 204.94,
    rx: 36.74,
    ry: 36.18,
    transform: "translate(79.88 522.25) rotate(-70.82)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,204.52a26.62,26.62,0,0,1-26,26.87,26,26,0,0,1-26.3-26,26.62,26.62,0,0,1,26-26.87A26,26,0,0,1,433.4,204.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,204.68A16.2,16.2,0,0,1,407.37,221a15.82,15.82,0,0,1-16-15.84,16.2,16.2,0,0,1,15.81-16.35A15.81,15.81,0,0,1,423.18,204.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.35,204.83a7.2,7.2,0,0,1-7,7.28,7,7,0,0,1-7.13-7.05,7.2,7.2,0,0,1,7-7.28A7,7,0,0,1,414.35,204.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.63,
    y: 148.51,
    width: 0.8,
    height: 76.85,
    transform: "translate(34.54 430.92) rotate(-62.4)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.92 170.74 336.09 170.67 339.21 169.71 333.06 166.49 329.73 167.5 335.92 170.74",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.32,162.55l1.11,3.24,6.15,3.21a14.62,14.62,0,0,1-1.09-3.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.76 204.15 407.47 206.46 404.06 206.17 406.3 204.33 406.53 201.45 408.76 204.15",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,298.35a11.08,11.08,0,0,1-3.4,10.21l-11.62,2.17a11.12,11.12,0,1,1,15-12.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.72,
    y: 309.61,
    width: 23.59,
    height: 3.4,
    transform: "translate(-54.13 36.49) rotate(-10.55)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.19,
    y: 355.65,
    width: 47.78,
    height: 3.4,
    transform: "translate(-62.42 38.84) rotate(-10.55)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.94,
    y: 365.02,
    width: 47.78,
    height: 3.4,
    transform: "translate(-64.11 39.32) rotate(-10.55)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.84,
    y: 358.97,
    width: 44.22,
    height: 6.13,
    transform: "translate(-63.26 39.08) rotate(-10.55)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.51,
    y: 312.96,
    width: 19.24,
    height: 3.4,
    transform: "translate(-54.72 36.66) rotate(-10.55)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,352.1l-38.43,7.16s7.13-10.4,7-21.24c-.12-9.13-1.46-20.5-1.46-20.5l12.68-2.36s2.84,11.09,6,19.65C187.58,345,198,352.1,198,352.1Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-29"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.68,
    cy: 463.12,
    rx: 92.02,
    ry: 9.45,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38.37 428.51 91.28 428.26 144.18 428.18 250 428.01 355.82 428.18 408.73 428.26 461.63 428.51 408.73 428.75 355.82 428.84 250 429.01 144.18 428.84 91.28 428.75 38.37 428.51",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.72,112.92A68.35,68.35,0,0,1,72.36,90.3,67.66,67.66,0,0,1,122.1,46.36,70.32,70.32,0,0,1,133.57,45c1,0,1.93-.06,2.89-.06l2.89.11c1.93,0,3.85.3,5.76.51a64.82,64.82,0,0,1,22,6.88A67.1,67.1,0,0,1,185.4,66.25,69.74,69.74,0,0,1,198,85.41a68.57,68.57,0,0,0-31.25-32.32,71.83,71.83,0,0,0-10.58-4.28c-1.83-.5-3.66-1-5.52-1.43l-2.8-.52-1.41-.27L145,46.43a54.33,54.33,0,0,0-5.69-.47l-2.85-.1c-1,0-1.9,0-2.85.06a70.51,70.51,0,0,0-11.31,1.42,67.62,67.62,0,0,0-21.1,8.38,69.33,69.33,0,0,0-17.13,15A68.12,68.12,0,0,0,68.72,112.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.22,63.27a64.26,64.26,0,0,1,10.89-11.1,66.26,66.26,0,0,1,28-13.22c1.28-.22,2.56-.49,3.84-.67s2.58-.35,3.87-.47l3.89-.21,3.89,0-3.87.24-3.85.43c-1.28.17-2.55.4-3.82.6s-2.52.54-3.78.8a75.06,75.06,0,0,0-27.7,13.07A79.47,79.47,0,0,0,79.22,63.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84,183.26a68.08,68.08,0,0,0,39.58-21.32,69.25,69.25,0,0,0,12.3-19.12,67.15,67.15,0,0,0,5.22-22.1,69.88,69.88,0,0,0-.23-11.39c-.12-.94-.22-1.89-.35-2.83l-.52-2.81a55.79,55.79,0,0,0-1.29-5.55c-.13-.46-.24-.92-.37-1.38l-.46-1.35-.93-2.7c-.67-1.78-1.45-3.52-2.22-5.26a72.25,72.25,0,0,0-5.77-9.83,68.54,68.54,0,0,0-36.51-26.23,69.44,69.44,0,0,1,20.78,9.66,67,67,0,0,1,16.36,16.12,64.74,64.74,0,0,1,10,20.72,57.55,57.55,0,0,1,1.34,5.63l.53,2.84c.14,1,.24,1.91.37,2.87a70.8,70.8,0,0,1,.28,11.56,67.2,67.2,0,0,1-58.1,62.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.7,113.89a79.71,79.71,0,0,0-1.95-15.34,74.93,74.93,0,0,0-12.83-27.81c-.8-1-1.55-2.06-2.38-3s-1.67-2-2.54-2.91L419.33,62l-2.82-2.68,3,2.48,2.84,2.66c.92.92,1.78,1.89,2.67,2.84s1.67,2,2.51,3a68.28,68.28,0,0,1,8.15,13.29,69.12,69.12,0,0,1,4.82,14.83A64.09,64.09,0,0,1,441.7,113.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.5,197.7a79.21,79.21,0,0,1-80.71,59.14,82,82,0,0,1-13.42-1.9c-1.1-.27-2.2-.52-3.29-.81l-3.24-1a66.39,66.39,0,0,1-6.37-2.31c-.52-.21-1.05-.41-1.57-.63l-1.53-.74L215.32,248c-1-.48-2-1.11-3-1.65s-2-1.12-2.93-1.72a78.66,78.66,0,0,1-10.74-8.24l-2.48-2.29-2.32-2.47c-1.61-1.6-3-3.41-4.4-5.15-.74-.85-1.35-1.8-2-2.72L185.54,221l-1.75-2.89c-.58-1-1.19-1.92-1.67-2.94a81.85,81.85,0,0,1-8.48-25.51,80.39,80.39,0,0,0,25.57,46.17,83.26,83.26,0,0,0,10.69,8.08c.94.59,1.93,1.12,2.89,1.69s1.92,1.15,2.94,1.62l3,1.44,1.51.73c.51.22,1,.41,1.56.61a61.43,61.43,0,0,0,6.3,2.27l3.21,1c1.08.28,2.17.52,3.25.79a82.3,82.3,0,0,0,13.26,1.83,78.9,78.9,0,0,0,26.5-3.1,79.76,79.76,0,0,0,54.16-55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.51,250.79A76,76,0,0,1,285.78,260a78.5,78.5,0,0,1-35.73,6.47c-1.52-.13-3-.21-4.56-.39s-3-.38-4.52-.64-3-.59-4.47-.92l-4.41-1.19,4.46.93c1.49.25,3,.46,4.49.7s3,.33,4.51.49,3,.16,4.53.25a84.55,84.55,0,0,0,18-1.35,85.44,85.44,0,0,0,17.36-5.05A91.85,91.85,0,0,0,301.51,250.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.07,179.06a56.47,56.47,0,0,1-4.32,16.33l10.14,7.28-5.25,9.08-11.34-5.13a57.27,57.27,0,0,1-11.9,12L289.54,230l-9.08,5.23-7.26-10.09a56.39,56.39,0,0,1-16.3,4.41L255.66,242H245.18l-1.24-12.38a56.8,56.8,0,0,1-16.32-4.31l-7.28,10.13-9.08-5.24,5.11-11.35a57.65,57.65,0,0,1-12-11.89L193,212,187.78,203l10.11-7.26a56.32,56.32,0,0,1-4.42-16.3L181,178.16V167.68l12.39-1.23a56.62,56.62,0,0,1,4.32-16.34l-10.14-7.28,5.25-9.07,11.34,5.12a57,57,0,0,1,11.9-12L211,115.53l9.08-5.25,7.25,10.1A56.62,56.62,0,0,1,243.61,116l1.23-12.41h10.48l1.24,12.38a56.16,56.16,0,0,1,16.32,4.31l7.29-10.13,9.07,5.25-5.11,11.34a57.7,57.7,0,0,1,12,11.9l11.38-5.14,5.24,9.09-10.11,7.25A56.09,56.09,0,0,1,307,166.09l12.44,1.25v10.49Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.49,126a46,46,0,0,1-6.84,16.8l7.4,9.13-11.56,11-8.21-7.41A46.6,46.6,0,0,1,145,162.81l-1.15,10.94L128,173.33,127.42,163a45.87,45.87,0,0,1-17.9-7.36l-8.11,6.57-11-11.54,6.73-7.45a46,46,0,0,1-7.28-18.11L79.58,124,80,108.08l10.24-.52A46,46,0,0,1,98,90l-6.86-8.46,11.55-11,8.1,7.31a46.49,46.49,0,0,1,17.33-6.64l1.21-11.55,15.91.42.59,11.6A46,46,0,0,1,162.32,79l9.46-7.68,10.95,11.56-8,8.88a46.22,46.22,0,0,1,6.74,16.48l12.15,1.27-.42,15.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.19,132.59l-11.8-.11,0-.2a50.22,50.22,0,0,0-1.39-5.55,8.49,8.49,0,0,0-2.28-2.6,19.09,19.09,0,0,1-7-13.37,18,18,0,0,1,4.64-13.3,16.76,16.76,0,0,1,24.66.22,18,18,0,0,1,4.41,13.39h0a19.1,19.1,0,0,1-7.3,13.24,8.29,8.29,0,0,0-2.32,2.56,50.27,50.27,0,0,0-1.5,5.52ZM130.8,132l11,.1a45.52,45.52,0,0,1,1.48-5.4,8.43,8.43,0,0,1,2.45-2.75c2.61-2.29,6.18-5.43,7.13-12.92a17.45,17.45,0,0,0-4.29-13,16.25,16.25,0,0,0-23.91-.21,17.46,17.46,0,0,0-4.52,12.91c.81,7.5,4.32,10.71,6.89,13.05a8.58,8.58,0,0,1,2.4,2.79A45.14,45.14,0,0,1,130.8,132Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.69,
    y: 113.98,
    width: 0.75,
    height: 18.44,
    transform: "translate(-19.45 24.91) rotate(-10.04)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.82,
    y: 122.91,
    width: 18.44,
    height: 0.75,
    transform: "translate(-7.09 237.95) rotate(-78.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.58,120.25h0c-1.07,0-2-1-2.63-2.18a1.32,1.32,0,0,1-1,.5h0c-1.74,0-2.4-3.57-2.43-3.72l.37-.06c.17.94.87,3.4,2.06,3.41h0a1.13,1.13,0,0,0,.79-.48,8,8,0,0,1-.81-3.22c0-1,.4-1.58,1.07-1.58h0a1.1,1.1,0,0,1,1,.56c.53.94.11,2.78-.58,3.94a2.36,2.36,0,0,1-.23.35c.61,1.17,1.46,2.1,2.38,2.11h0c.84,0,1.58-.75,2.12-1.76a4.75,4.75,0,0,1-1-3.07c0-1.29.51-2.09,1.3-2.08h0c.64,0,1,.64,1,1.74a8.45,8.45,0,0,1-.85,3.34,1.56,1.56,0,0,0,1.09.45h0c1,0,1.94-2.45,2.22-3.4l.36.1c-.11.38-1.11,3.69-2.59,3.68h0a2,2,0,0,1-1.26-.5A3,3,0,0,1,136.58,120.25Zm2.41-6.91c-.68,0-.92.92-.93,1.71a4.67,4.67,0,0,0,.82,2.71,8,8,0,0,0,.74-3.05c0-.41-.05-1.37-.63-1.37Zm-5,0c-.57,0-.69.66-.7,1.22a7.59,7.59,0,0,0,.69,2.88l.09-.16c.63-1,1-2.78.57-3.56a.71.71,0,0,0-.65-.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,134.86,129,134.73l0-3.25,14.56.13Zm-14.05-.63,13.55.13,0-2.25L129.52,132Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,138.05,129,137.92l0-3.25,14.56.13Zm-14.05-.63,13.56.13,0-2.25-13.56-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.49,141.24l-14.56-.13,0-3.25,14.56.14Zm-14.05-.63,13.56.13,0-2.25-13.56-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,154.8l-9.87-8.42.12-.19c.1-.15,2.44-3.58,5.78-4a5.91,5.91,0,0,1,4.71,1.58,6,6,0,0,1,2.34,4.44c.13,3.41-2.79,6.34-2.91,6.46Zm-9.2-8.51,9.17,7.82c.6-.66,2.72-3.17,2.61-5.93a5.54,5.54,0,0,0-2.16-4.07,5.41,5.41,0,0,0-4.32-1.46C266.44,143,264.36,145.58,263.83,146.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.68 200.03 235.29 199.71 272.88 154.23 263.73 146.43 226.15 191.9 225.76 191.58 263.67 145.72 273.58 154.17 273.43 154.36 235.68 200.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.77,156.81,261.26,147l1.82-2.2,11.5,9.82ZM262,146.93l10.74,9.17,1.19-1.43-10.75-9.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.11,158.81,259.6,149l1.82-2.2,11.51,9.81Zm-10.81-9.87L271,158.1l1.19-1.43-10.75-9.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.34,203.5l1.46-11.77H226l1.81-.3.29-.05v1.88L230,193v1.88l1.84-.31v1.88l1.82-.32,0,1.89,1.54-.27.28,0,0,2.37Zm1.91-11.3-1.32,10.59,2.27-.7,7.79-2.43,0-1.42-1.53.27-.29.05,0-1.89-1.83.32v-1.88l-1.84.31v-1.88l-1.84.31V192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.52,203.16l.6-4.73,3.92,3.34Zm1-3.75-.39,3.05,2.91-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.9,191.17c2.38-3.32,4.88-6.55,7.4-9.76s5.12-6.35,7.68-9.54,5.23-6.25,7.91-9.33,5.39-6.14,8.2-9.11c-2.38,3.33-4.88,6.55-7.4,9.77s-5.12,6.35-7.68,9.53-5.23,6.26-7.92,9.33S233.71,188.2,230.9,191.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.23,194.77c2.39-3.33,4.89-6.55,7.4-9.77s5.12-6.35,7.68-9.53,5.23-6.26,7.92-9.34,5.38-6.14,8.19-9.1c-2.38,3.32-4.88,6.55-7.4,9.76s-5.12,6.36-7.68,9.53-5.23,6.26-7.91,9.34S238,191.8,235.23,194.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.3,126a46,46,0,0,1-6.84,16.8l7.4,9.13-11.56,11-8.21-7.41a46.6,46.6,0,0,1-17.27,7.35l-1.15,10.94-15.91-.42L354.23,163a45.87,45.87,0,0,1-17.9-7.36l-8.11,6.57-11-11.54,6.73-7.45a45.89,45.89,0,0,1-7.28-18.11L306.39,124l.42-15.92,10.24-.52A45.9,45.9,0,0,1,324.82,90L318,81.56l11.55-11,8.1,7.31a46.49,46.49,0,0,1,17.33-6.64l1.21-11.55,15.91.42.59,11.6A46.09,46.09,0,0,1,389.13,79l9.45-7.68,11,11.56-8,8.88a46.22,46.22,0,0,1,6.74,16.48l12.15,1.27L420,125.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.37,143.79h-2.44V96.71h2.44Zm-1.94-.5h1.44V97.21h-1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.28,120.5H349.87V97.77h33.41l-11.39,11.36Zm-32.91-.5h31.7l-10.89-10.87,10.89-10.86h-31.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Process--inject-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 281.96,
    width: 211.02,
    height: 13.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.51,295.28l-211,.36h-.36v-.36l0-13.32v-.38h.38L250,281.7l105.51.22h0v0Zm0,0,0-13.32,0,0L250,282.22l-105.51.11.37-.37v13.32l-.36-.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.06,
    y: 284.31,
    width: 136.54,
    height: 8.62,
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.79 284.31 153.72 284.31 147.06 292.93 154.13 292.93 160.79 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.44 284.31 167.37 284.31 160.7 292.93 167.77 292.93 174.44 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.09 284.31 181.02 284.31 174.35 292.93 181.42 292.93 188.09 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.73 284.31 194.66 284.31 187.99 292.93 195.06 292.93 201.73 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.38 284.31 208.31 284.31 201.64 292.93 208.71 292.93 215.38 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.02 284.31 221.96 284.31 215.29 292.93 222.36 292.93 229.02 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.67 284.31 235.6 284.31 228.93 292.93 236 292.93 242.67 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.32 284.31 249.25 284.31 242.58 292.93 249.65 292.93 256.32 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.96 284.31 262.89 284.31 256.23 292.93 263.3 292.93 269.96 284.31",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.59 284.34 283.59 284.31 276.54 284.31 269.87 292.93 276.94 292.93 283.59 284.34",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.59 292.93 283.59 292.84 283.52 292.93 283.59 292.93",
    style: {
      opacity: 0.1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232,304.07H231v1.66a.42.42,0,0,1-.42.42.43.43,0,0,1-.43-.42v-4.52a.42.42,0,0,1,.43-.42H232a1.64,1.64,0,1,1,0,3.28Zm-.95-.85H232a.79.79,0,1,0,0-1.58H231Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238.18,305.51a.42.42,0,0,1-.27.54l-.16,0h0a.54.54,0,0,1-.3-.08.82.82,0,0,1-.25-.27,2.17,2.17,0,0,1-.16-.92.56.56,0,0,0-.09-.33.7.7,0,0,0-.23-.22,1.22,1.22,0,0,0-.43-.18h-.9v1.66a.42.42,0,0,1-.43.42.42.42,0,0,1-.42-.42v-4.52a.41.41,0,0,1,.42-.42h1.37a1.64,1.64,0,0,1,1.64,1.65,1.6,1.6,0,0,1-.6,1.25,1.44,1.44,0,0,1,.27.28,1.51,1.51,0,0,1,.25.83,3.06,3.06,0,0,0,0,.45A.41.41,0,0,1,238.18,305.51Zm-1.07-3.07a.79.79,0,0,0-.79-.8h-.94v1.58h.94A.79.79,0,0,0,237.11,302.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.52,301.46a2.82,2.82,0,0,1,0,3.87,2.5,2.5,0,0,1-1.83.82,2.58,2.58,0,0,1-1.88-.82,2.84,2.84,0,0,1,0-3.87,2.54,2.54,0,0,1,1.88-.82A2.47,2.47,0,0,1,243.52,301.46Zm-.1,1.93a2,2,0,0,0-.52-1.34,1.66,1.66,0,0,0-2.45,0,2,2,0,0,0,0,2.68,1.64,1.64,0,0,0,2.45,0A2,2,0,0,0,243.42,303.39Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.33,303.39a2.81,2.81,0,0,1,2.81-2.75,2.9,2.9,0,0,1,1.77.59.48.48,0,0,1,.08.62.46.46,0,0,1-.62.08,1.87,1.87,0,0,0-1.23-.42,2,2,0,0,0-1.38.55,1.87,1.87,0,0,0,0,2.67,2.06,2.06,0,0,0,1.38.55,2,2,0,0,0,1.23-.42.48.48,0,0,1,.62.08.46.46,0,0,1-.08.61,2.84,2.84,0,0,1-1.77.6A2.8,2.8,0,0,1,245.33,303.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.47,305.73v-4.52a.41.41,0,0,1,.42-.42h2.5a.42.42,0,0,1,.42.42.42.42,0,0,1-.42.43h-2.07V303h1.78a.43.43,0,0,1,.42.42.42.42,0,0,1-.42.43h-1.78v1.41h2.07a.43.43,0,0,1,0,.85h-2.5A.42.42,0,0,1,251.47,305.73Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.84,304.82a.41.41,0,0,1,.56-.06,2.41,2.41,0,0,0,1.46.59,1.65,1.65,0,0,0,1-.28.69.69,0,0,0,.33-.55.52.52,0,0,0-.07-.25,1,1,0,0,0-.23-.23,3.43,3.43,0,0,0-1.05-.36h0a4.1,4.1,0,0,1-1-.29,1.66,1.66,0,0,1-.71-.6,1.24,1.24,0,0,1-.17-.63,1.42,1.42,0,0,1,.61-1.12,2.24,2.24,0,0,1,1.32-.4,3,3,0,0,1,1.67.61.39.39,0,0,1,.11.54.38.38,0,0,1-.54.12,2.24,2.24,0,0,0-1.24-.49,1.39,1.39,0,0,0-.85.26.61.61,0,0,0-.3.48.35.35,0,0,0,.06.21.63.63,0,0,0,.2.2,2.71,2.71,0,0,0,1,.34h0a4.81,4.81,0,0,1,1.05.32,1.8,1.8,0,0,1,.77.64,1.18,1.18,0,0,1,.18.65,1.49,1.49,0,0,1-.65,1.19,2.46,2.46,0,0,1-1.42.43,3.25,3.25,0,0,1-2-.76A.41.41,0,0,1,255.84,304.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.86,304.82a.41.41,0,0,1,.56-.06,2.47,2.47,0,0,0,1.47.59,1.62,1.62,0,0,0,.95-.28.69.69,0,0,0,.33-.55.43.43,0,0,0-.07-.25.77.77,0,0,0-.22-.23,3.43,3.43,0,0,0-1.05-.36h0a4.1,4.1,0,0,1-1-.29,1.66,1.66,0,0,1-.71-.6,1.25,1.25,0,0,1-.18-.63,1.4,1.4,0,0,1,.62-1.12,2.24,2.24,0,0,1,1.32-.4,3,3,0,0,1,1.67.61.4.4,0,0,1-.44.66,2.21,2.21,0,0,0-1.23-.49,1.44,1.44,0,0,0-.86.26.62.62,0,0,0-.29.48.35.35,0,0,0,.06.21.54.54,0,0,0,.2.2,2.71,2.71,0,0,0,1,.34h0a4.81,4.81,0,0,1,1.05.32,1.8,1.8,0,0,1,.77.64,1.26,1.26,0,0,1,.18.65,1.48,1.48,0,0,1-.66,1.19,2.41,2.41,0,0,1-1.41.43,3.25,3.25,0,0,1-2-.76A.41.41,0,0,1,260.86,304.82Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266.54,305.06a.58.58,0,0,1,.57.58.57.57,0,0,1-.57.56.56.56,0,0,1-.57-.56A.57.57,0,0,1,266.54,305.06Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.3,305.06a.58.58,0,0,1,.57.58.57.57,0,0,1-.57.56.56.56,0,0,1-.57-.56A.57.57,0,0,1,268.3,305.06Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.06,305.06a.58.58,0,0,1,.57.58.57.57,0,0,1-.57.56.56.56,0,0,1-.57-.56A.57.57,0,0,1,270.06,305.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.48,161.12c3.12,23.06,13.26,46.75,17.08,50.32,4.16,3.9,24.87,5.95,35.38,6.47,3.44.18,6.13-23.43,3.36-25.86s-20.61.26-23.68-2c-1-.72-15.31-19.7-22.8-31C101.83,148.49,98.53,154.11,99.48,161.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,221.24l3.36-31.18s-17.16.79-19.31-.74-18.48-24.23-24.62-32-13.38-7.5-9,10.69c4.68,19.65,11.39,39.33,15.52,43.44C120.31,216.83,149,221.24,149,221.24Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.49,217.86a27,27,0,0,1,.27-3.35c.08-1,.15-2,.24-3,.21-2.18.41-4.35.63-6.52s.42-4.34.66-6.51.41-4.32.76-6.46a.08.08,0,0,1,.15,0c.06,2.17-.09,4.35-.21,6.52s-.31,4.27-.52,6.39-.49,4.33-.78,6.49c-.14,1-.32,2.08-.49,3.11a24.55,24.55,0,0,1-.6,3.32A.06.06,0,0,1,142.49,217.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.94,218.58c-8.1-1.8-17.23-4.34-20.06-7.16C110.75,207.31,104,187.63,99.36,168c-2.75-11.56-.83-15.89,2.51-15.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.44,150.84a24.75,24.75,0,0,1,25.45-5.65l-14.5,14.16,4.9,10.62,10.5,5.16L197.31,161a24.76,24.76,0,1,1-40.87-10.12Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.21,285.69a24.72,24.72,0,0,1-25.44,5.65l14.5-14.16-4.9-10.62L62.86,261.4,48.35,275.57a24.76,24.76,0,1,1,40.86,10.12Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.82,
    y: 156.08,
    width: 22.06,
    height: 120.42,
    transform: "translate(57.3 456.72) rotate(-134.31)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.31,
    y: 191.5,
    width: 9.08,
    height: 49.59,
    transform: "translate(57.3 456.72) rotate(-134.31)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.39,210.54c-.32-3.29,3.74-1.78,3.74-1.78s-5.33-3.58-4.35-7.1,5.8-1.4,6.15-1.26c-.28-.19-5.09-3.61-3.74-7s5.92-.74,6.21-.56c-.2-.26-2.89-3.8-1.27-6.17,2.78-4.09,11.31,5.37,15.3,5.63l4.92-5.6a9.85,9.85,0,0,0,.21,5.63c.8,2.64,1.35,4.41,1.05,6.11a3.63,3.63,0,0,1-3.05,3.07s2.53,2.42,1.56,5.16c-.51,1.4-3.21,1.85-3.21,1.85a4.31,4.31,0,0,1,.93,4.4c-.81,1.91-3.39,2.05-3.39,2.05s1,2.82-.49,4.49C155,222.81,138.08,217.59,137.39,210.54Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,191.15l3.5-4.37c.17-.13.34-.27.5-.38,5.82-4.18,14.66-1.74,11.53,2.33-2.38,3.1-9,2.55-11,6.08h0Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05,215a0,0,0,0,1,0,.09,30.76,30.76,0,0,1-17.14-6.41c-.15-.13,0-.43.18-.33A62.77,62.77,0,0,0,158.05,215Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,208.54c.07,0,0,.12,0,.12a28.85,28.85,0,0,1-18.27-8.16c-.16-.17-.14-.5.07-.31C146.25,203.3,155.39,207.32,161,208.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,192.34c4.85,4.65,10.71,7.29,17.11,9.13.09,0,0,.14,0,.14-3.38-.05-7.34-1.65-10.32-3.15a17.85,17.85,0,0,1-6.93-6C145,192.4,145.08,192.24,145.19,192.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,463.52c-2.31.72-67.69-.68-70.15-2.31-.93-.61-1.28-10.15-1.38-21.68,0-2.49,0-5.06,0-7.68,0-3.09,0-6.22.06-9.26.18-13.66.59-28.68.59-28.68l42.56.79-.49,28.68-.18,9.26-.37,7.67s24.79,11.74,27.3,13.81S171.3,462.81,169,463.52Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,463.52c-2.31.72-67.69-.68-70.15-2.31-.93-.61-1.28-10.15-1.38-21.68,0-2.49,0-5.06,0-7.68,0-3.09,0-6.22.06-9.26l42.66.79-.18,9.26-.37,7.67s24.79,11.74,27.3,13.81S171.3,462.81,169,463.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.2,463.62c-1.5.46-29.35.05-49.62-.75-4.69-.19-9-.39-12.44-.61-4.76-.31-8-.63-8.47-1-1.14-.76-1.43-14.75-1.42-29.51l42.78.79-.37,7.71s24.93,11.8,27.45,13.89S171.51,462.89,169.2,463.62Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.31,461c-11-.51-55.49-1.51-66.41-1.17-.09,0-.09.06,0,.07,10.9.74,55.38,1.38,66.41,1.28C168.54,461.15,168.55,461,168.31,461Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27,437.86c-4.32-.9-9.64-.35-13,2.67-.13.12,0,.3.18.26a61.83,61.83,0,0,1,12.81-2.38A.28.28,0,0,0,141.27,437.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36,439.82c-4.32-.9-9.64-.35-13,2.67-.13.11,0,.3.18.26a60.54,60.54,0,0,1,12.81-2.38A.28.28,0,0,0,144.36,439.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.45,441.77c-4.32-.9-9.64-.35-13,2.67-.13.12,0,.3.18.26a60.54,60.54,0,0,1,12.81-2.38A.28.28,0,0,0,147.45,441.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.54,443.72c-4.32-.9-9.64-.35-13,2.67-.13.12,0,.3.18.26a61.83,61.83,0,0,1,12.81-2.38A.28.28,0,0,0,150.54,443.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5,428c-1.66-2.39-4.85-1.4-6.7.08a23.23,23.23,0,0,0-6.89,9.79.12.12,0,0,0,.1.16c0,.33.29.69.67.56,3.61-1.25,7.62-2.14,10.74-4.46C149.24,432.79,151.06,430.26,149.5,428Zm-7.74,7.58c-1.76.65-3.54,1.22-5.27,1.94,1.35-1.9,2.61-3.86,4.15-5.63a24.48,24.48,0,0,1,2.35-2.43c1.31-1.15,6.48-3.54,5.61,1.21C148.12,433.29,143.86,434.8,141.76,435.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.91,436.52c3.55,1.6,7.66,1.61,11.45,2.06a.54.54,0,0,0,.53-.69.12.12,0,0,0,.07-.18,23.22,23.22,0,0,0-8.83-8.09c-2.11-1.05-5.45-1.34-6.55,1.35C120.53,433.5,122.85,435.58,124.91,436.52ZM123,433.38c-1.86-4.45,3.7-3.21,5.23-2.37a23.64,23.64,0,0,1,2.81,1.87,69.94,69.94,0,0,1,5.26,4.61c-1.85-.33-3.71-.5-5.57-.77C128.53,436.4,124.05,435.83,123,433.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,463.38c-5.51-.14-11.07-.32-16.16-.51-4.69-.18-9-.39-12.44-.61-4.76-.31-8-.63-8.47-1-1-.67-1.35-11.48-1.41-24.07C107,443.71,126,456.74,135.74,463.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.84,435.78l-45.58.05s2.67-108.34,2.14-110.89c-1.25-6.08-28.87-102.48-28.87-102.48l38.35.66,7,.23s24.33,81.07,26.89,95.88C145.21,344.88,140.84,435.78,140.84,435.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26,427.66c-7.57-.19-30.41-1-40.52-.24-.07,0-.07.14,0,.15,3.46.56,32.94.4,40.52.3A.11.11,0,1,0,138.26,427.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.21,322.52c-1.45-5.91-12.27-42.73-15.58-54.36s-6.41-23.31-9.26-35.05c-.37-1.49-.73-3-1.13-4.46,0-.12-.21-.07-.19.06,1.09,5.91,2.54,11.77,3.93,17.62s2.87,11.68,4.43,17.49q4.7,17.52,10.26,34.78c1.85,5.74,4.91,17.51,6.53,23.31s-1,100-.86,101.57a.35.35,0,0,0,.69,0C100.24,412.25,102.65,328.36,101.21,322.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,223.11s-9.38,102.32-9.48,101.82c-1.21-5.88-27.18-96.53-28.81-102.2-.06-.18-.08-.27-.08-.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63,466.12c-2.31.72-67.69-.68-70.15-2.31-.93-.61-1.28-10.15-1.38-21.68,0-2.49,0-5.05,0-7.67,0-3.1,0-6.23.07-9.27.17-13.65.58-25.68.58-25.68l42.57.79L89.8,426l-.18,9.26-.36,7.67s24.79,11.74,27.29,13.82S120.92,465.41,118.63,466.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63,466.12c-2.31.72-67.69-.68-70.15-2.31-.93-.61-1.28-10.15-1.38-21.68,0-2.49,0-5.05,0-7.67,0-3.1,0-6.23.07-9.27L89.8,426l-.18,9.26-.36,7.67s24.79,11.74,27.29,13.82S120.92,465.41,118.63,466.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82,466.22c-1.5.47-29.35,0-49.62-.74-4.69-.19-9-.4-12.43-.62-4.77-.3-8-.62-8.48-1-1.14-.76-1.43-14.76-1.42-29.52l42.78.79-.37,7.71s24.93,11.8,27.46,13.89S121.13,465.5,118.82,466.22Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,463.57c-11-.5-55.49-1.51-66.42-1.17-.09,0-.09.06,0,.07,10.9.74,55.39,1.38,66.41,1.28C118.16,463.75,118.17,463.58,117.94,463.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.89,440.47c-4.32-.9-9.63-.35-13,2.67-.14.11,0,.3.17.26A60.66,60.66,0,0,1,90.86,441,.28.28,0,0,0,90.89,440.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,442.42c-4.32-.9-9.63-.35-13,2.67-.14.12,0,.3.17.26A60.66,60.66,0,0,1,94,443,.28.28,0,0,0,94,442.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07,444.37c-4.32-.9-9.63-.35-13,2.67-.14.12,0,.3.17.26A62,62,0,0,1,97,444.92.28.28,0,0,0,97.07,444.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.16,446.33c-4.32-.9-9.63-.35-13,2.67-.14.11,0,.3.17.26a60.66,60.66,0,0,1,12.81-2.38A.28.28,0,0,0,100.16,446.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.12,430.61c-1.66-2.38-4.85-1.4-6.69.09a23.11,23.11,0,0,0-6.9,9.79c0,.09,0,.14.1.16,0,.33.3.68.67.55,3.61-1.25,7.62-2.14,10.74-4.46C98.86,435.39,100.68,432.86,99.12,430.61Zm-7.73,7.58c-1.76.66-3.55,1.22-5.28,1.95a69.14,69.14,0,0,1,4.15-5.63,24.62,24.62,0,0,1,2.35-2.44c1.32-1.14,6.48-3.53,5.61,1.21C97.74,435.89,93.48,437.41,91.39,438.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.54,439.12c3.54,1.6,7.65,1.61,11.44,2.06.39.05.6-.36.54-.69a.11.11,0,0,0,.06-.17,23.17,23.17,0,0,0-8.83-8.1c-2.11-1.05-5.45-1.33-6.55,1.35S72.47,438.19,74.54,439.12ZM72.64,436c-1.86-4.45,3.7-3.22,5.23-2.38a25.39,25.39,0,0,1,2.81,1.87,66.08,66.08,0,0,1,5.26,4.62c-1.85-.34-3.71-.51-5.57-.78C78.15,439,73.67,438.44,72.64,436Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.12,439.73,45,438.86s13.23-168,11.58-177c-2.69-14.74-.39-31.57,6.7-39.56l45.93.85s.67,19.44-4.21,27.05c0,0-4.36,2.65-6.48,3.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.82,431.36c-7.15-.32-4.09-.33-11.24-.57-3.5-.11-26.49-.86-29.78-.4-.07,0-.07.13,0,.15,3.26.62,26.26,1,29.76,1,7.15.11,4.1,0,11.25,0A.11.11,0,0,0,89.82,431.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,261.4c-.26-3.38-.75-6.74-1.06-10.12a62.68,62.68,0,0,1,1.6-20.19.1.1,0,0,0-.19-.05c-1.23,5.85-2.32,11.7-2.13,17.71s1.12,11.85,1.11,17.82-.6,12.07-1.1,18.09-1,12.11-1.51,18.17c-2,24.34-3.91,48.68-5.85,73-.54,6.8-1,13.59-1.57,20.39s-1.33,22-1.71,28.9c0,.6.86.57.92,0,1.26-12.21,2.28-32.62,3.28-44.85s1.93-24.22,2.9-36.33,1.91-24.22,2.86-36.33q.7-9.09,1.39-18.17c.46-6,1-12.06,1.22-18.11A89.44,89.44,0,0,0,64,261.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,238c0-.09-.1-.23-.18-.15a27.55,27.55,0,0,1-9.45,9.34c-4.55,2.78-10.79,4.22-14.27,4.65-.23,0-.15.22.06.23,3.67.23,8.77-.71,14.35-3.72C89.55,244,90.87,238.87,91,238Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.38,249.63a77.61,77.61,0,0,0-12.23,5.69c-.15.09-.05.33.12.25,4.11-1.76,8.31-3.46,12.33-5.45A.27.27,0,0,0,106.38,249.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.81,223.51c0-.13-.26-.16-.26,0a117.75,117.75,0,0,1-.75,12.68c-.21,2-2,12.76-5.64,12-.61-.13-.92-.68-1-1.54a12.6,12.6,0,0,1,.51-3.31c.42-2.27.76-4.54,1-6.82a57.39,57.39,0,0,0-.09-12.77.12.12,0,0,0-.24,0,108.59,108.59,0,0,1-1.2,17.64c-.48,2.81-2,7,1.15,7.46s5.38-6.66,5.79-8.6A60.11,60.11,0,0,0,107.81,223.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26,248.42a18.3,18.3,0,0,0-.83,2.43,5.28,5.28,0,0,0-.34,2c0,.13.18.14.25.06a7.42,7.42,0,0,0,.86-2c.28-.75.57-1.49.83-2.25A.41.41,0,0,0,101.26,248.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.46,236.25c.15.18,64.09,1.66,64.73,1,.9-.95-4.93-68.24-15.47-83.29-2.63-3.76-12.23-6.48-16.32-2.78C75.57,161.86,73,171,69.79,178.45c-2.34,5.51-5.23,14.94-7.86,24.62C57.58,219,53.92,235.59,54.46,236.25Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,160.12c-13.22,16-28.31,45.1-26.35,51.12,5.31,16.37,10.58,30.52,15.89,39.37C70,254.7,92.61,242,90.33,238c-4.68-8.1-13.7-27.59-15.1-30.35-.81-1.59,6.76-27.81,11.33-42.29C91.53,149.63,84.38,152.38,78,160.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.81,245l27.85-13.61s-11-24.43-11-27.07,9-32.25,11.74-41.8S87.15,147,75.26,161.39s-24.09,38-25.27,43.68S59.81,245,59.81,245Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,177.52c.72-1.94,1.53-3.84,2.31-5.77.06-.13.3,0,.25.1-.92,2.57-1.79,5.17-2.65,7.76.65-1.18,1.31-2.36,2-3.52a.09.09,0,0,1,.16.09c-.78,1.43-1.6,2.84-2.43,4.24-.21.63-6.29,22.3-6.35,23.13a7.5,7.5,0,0,0,.42,2.77c.5,1.63,1.07,3.25,1.65,4.86,1.16,3.23,2.42,6.43,3.75,9.6,1.51,3.6,3.23,7.17,4.94,10.68,0,0-1,.28-1.07.3s-.08,0-.06-.06.66-.34.68-.34c-1.75-3.05-3.41-6-4.87-9.23s-2.75-6.39-3.92-9.66c-.6-1.69-1.18-3.38-1.72-5.09a9.6,9.6,0,0,1-.47-5C77,200.66,83.21,179.52,84,177.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.36,237.1a27.21,27.21,0,0,1,3-1.43c.9-.43,1.8-.86,2.72-1.27,2-.9,4-1.81,6-2.7s4-1.78,6-2.65,4-1.79,6-2.54c.07,0,.13.09.06.13-1.85,1.13-3.83,2.08-5.77,3.05s-3.85,1.85-5.8,2.72-4,1.73-6,2.55c-1,.39-2,.75-3,1.11a24.56,24.56,0,0,1-3.18,1.13A.05.05,0,0,1,59.36,237.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,160.8c-2.83.5-9.44-4-12.33-8.21-.2-.29-.07-3.54-.1-7.5,0-2.4-.12-5.07-.38-7.51l15.66,2.1a39.18,39.18,0,0,0-.49,9.5,7.2,7.2,0,0,0,.21,1s0,.1,0,.16C102.46,152.2,103.76,160,99.34,160.8Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.91,150.17a1.42,1.42,0,0,0,0,.16,10.12,10.12,0,0,1-1.57.25c-8.87.74-12.22-9.92-13-12.87l14.78,2a39.18,39.18,0,0,0-.49,9.5A7.2,7.2,0,0,0,101.91,150.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.08,117c-1.75,5.41.88,21.18,4.69,24.75,5.54,5.17,14.72,5.8,19.14-.88,4.29-6.47.5-27-3.77-30.22C97.84,105.84,86.66,109,84.08,117Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,126.84s-.07.06-.06.11c.22,1,.31,2.29-.59,2.82,0,0,0,.07,0,.06C100.33,129.45,100.21,127.8,99.82,126.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.67,125.91c-1.72.18-1.23,3.62.37,3.45S100.12,125.75,98.67,125.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.87,125.87s.09,0,.09.08c.12,1.07.44,2.28,1.45,2.49,0,0,0,.07,0,.07C106.21,128.51,105.81,126.9,105.87,125.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66,124.62c1.69-.38,2.32,3,.75,3.39S105.24,124.93,106.66,124.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.09,124.53a13.67,13.67,0,0,0,1.26-.66,2.34,2.34,0,0,0,1.17-.92.75.75,0,0,0-.25-.87,1.82,1.82,0,0,0-1.84.08,2.71,2.71,0,0,0-1.37,1.36A.79.79,0,0,0,97.09,124.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.66,123.11a14,14,0,0,1-1.42-.16,2.34,2.34,0,0,1-1.41-.44.74.74,0,0,1-.09-.89,1.83,1.83,0,0,1,1.75-.6,2.72,2.72,0,0,1,1.77.78A.79.79,0,0,1,107.66,123.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.93,136.91c.29.22.59.52,1,.5A2.8,2.8,0,0,0,102,137a0,0,0,0,1,.06.05,1.45,1.45,0,0,1-1.27.77,1.14,1.14,0,0,1-1-.82C99.81,136.92,99.89,136.88,99.93,136.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,133.56a3.68,3.68,0,0,0,2.66,1.27,4.49,4.49,0,0,0,1.31-.13.94.94,0,0,0,.24-.06l.23-.07a.27.27,0,0,0,.18-.27h0s0-.07,0-.11h0v-.1c-.1-.82-.35-2.06-.35-2.06.32.11,1.94.58,1.86.15a55.11,55.11,0,0,0-3-10.78.1.1,0,0,0-.19.06c.55,3.41,1.71,6.69,2.32,10.11a6.21,6.21,0,0,0-1.78-.27c-.11.05.54,2.38.55,2.75a0,0,0,0,1,0,0,5.07,5.07,0,0,1-3.92-.63C100.59,133.4,100.51,133.49,100.59,133.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,134.36a4.39,4.39,0,0,1-1.54,1.58,2,2,0,0,1-1.16.24c-.89-.1-1-.88-1-1.57a4.66,4.66,0,0,1,.24-1.08A5.63,5.63,0,0,0,104,134.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.48,135.94a2,2,0,0,1-1.16.24c-.89-.1-1-.88-1-1.57A2,2,0,0,1,102.48,135.94Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,116.65c-.23-.44-1.57-3.55-2.19-3.52-.78,0-1.2,1.35-2.63,1.86-2,.73-5.77-1.26-8.54-.28s-4.25,3.79-4.42,8.86-3.84,9.42-5.21,6.2c0-.12-.13-.33-.25-.62-.78-4.79-1.17-10.41-.34-13,2.57-8,15.11-10.12,20.63-6A8.15,8.15,0,0,1,107.42,116.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.55,130.31s-3.58-5.07-5.88-3.79.4,8.64,3.11,9.63a2.75,2.75,0,0,0,3.69-1.49Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5,128.61s-.06.06,0,.07c1.9.76,2.91,2.52,3.62,4.34a1.52,1.52,0,0,0-2.28-.4s0,.11.05.1a1.7,1.7,0,0,1,1.87.58,7.93,7.93,0,0,1,.9,1.51c.09.17.4.08.33-.12v0C88,132.22,86.1,128.84,83.5,128.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.31,151.7l-1.64,7.7-13.8-10-2.78,4.1s13.32,17.08,13.29,16.24l3.88-8.57,5,5.07-1.62-11.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.67,159.4c-.42-2.26-.33-2.44-.85-4.68,0-.08-.15-.1-.16,0-.19,2.25,1,8.77,1.24,10.85l0,0c-.26-.21-4.58-4.45-4.62-4.38-.67,1.35-3.8,7.66-3.93,8.2-2.11-2.71-10.12-12.53-12.53-15.05a.08.08,0,0,0-.13.09c1.93,2.91,12.56,16.15,12.69,16.1a72.4,72.4,0,0,0,4-9c.93.9,5.37,5.73,5.35,5.39A72.32,72.32,0,0,0,105.67,159.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.24,375.19a225.15,225.15,0,0,0-.32-23.67,302.22,302.22,0,0,0-7.42-48.23c-2.07-8.93-4.61-17.7-7.27-26.47-.08-.26-.5-.19-.43.09,8.21,30.9,14.94,62.78,14.48,94.9-.13,9-1.17,17.82-2,26.75,0,.24.37.33.43.09A135,135,0,0,0,420.24,375.19Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.8,276.91s-12.43,31.55-9.64,39,8.52,9,8.52,9-7.61,10.86-2.29,21.05,17.12,9.7,17.9,21.25C419.29,367.17,420,318.88,404.8,276.91Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.94,347.23a.25.25,0,0,0,0-.17,288.91,288.91,0,0,0-12.06-63.46c0-.07-.12-.05-.1,0q3.69,13.85,6.53,27.83a13.78,13.78,0,0,0-5.94-3.3s-.06,0,0,.06a15.79,15.79,0,0,1,6.13,4.09c.36,1.83.72,3.66,1,5.49-2.77-3.1-6.63-4.64-10.48-6.11-.06,0-.08.07,0,.09,4,1.63,8,3.74,10.73,7.2q1.42,7.84,2.5,15.76a15.05,15.05,0,0,0-7.41-4.25c-.09,0-.14.11-.05.13a15.73,15.73,0,0,1,7.52,4.82s0,0,0,0c.25,1.86.49,3.71.71,5.57a19.26,19.26,0,0,0-5.2-3.13c-.05,0-.08.06,0,.08a17.82,17.82,0,0,1,5.21,3.44l.06,0c.21,1.77.42,3.53.59,5.3a25.19,25.19,0,0,0-10.54-7.52c-.08,0-.12.09,0,.12a27.64,27.64,0,0,1,10.39,8,.23.23,0,0,0,.26.08c.27,2.72.51,5.43.71,8.16a0,0,0,1,0,.06,0C418.36,352.8,418.17,350,417.94,347.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,305a15.58,15.58,0,0,0-7.46-2.33.05.05,0,0,0,0,.1,29.28,29.28,0,0,1,7.38,2.41C408,305.24,408.05,305.07,408,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.46,338.41a15.64,15.64,0,0,0-5.6-1.91.05.05,0,1,0,0,.1,21.19,21.19,0,0,1,5.55,1.95C409.47,338.59,409.54,338.46,409.46,338.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.92,316.39A84.55,84.55,0,0,0,438.53,329a51.68,51.68,0,0,0-10.09,17.11A128.14,128.14,0,0,0,420.92,387a99.49,99.49,0,0,0,2.22,23,.22.22,0,0,0,.43-.08,128.93,128.93,0,0,1,.23-40.23c2.13-13,5.49-27.25,13.78-37.86,4.52-5.78,10.15-10.32,15.72-15C453.59,316.59,453.22,316.18,452.92,316.39Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.75,377.61a77.44,77.44,0,0,1,10.49-13.41c6.22-6.22,11.46-10.63,12.26-14.75s-6.22-7.14-6.22-7.14,8.6,1.55,11-2.06,3.49-24.53,3.49-24.53-15.66,11.18-23,26.84S422.75,377.61,422.75,377.61Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.31,321.08c-6.59,6.47-13.22,13.37-17.09,21.86a83.09,83.09,0,0,0-3.46,9h0c-.2.62-.4,1.24-.59,1.86a.19.19,0,0,0,0,.1,178.67,178.67,0,0,0-4.45,19.33s.06.06.07,0c.67-3.27,1.41-6.56,2.25-9.85h.09a13.9,13.9,0,0,1,4.11-1.05c.09,0,.08-.17,0-.16a15.08,15.08,0,0,0-4.06.74c.75-3,1.58-5.92,2.5-8.83a44.14,44.14,0,0,1,9.29-1.22s0,0,0,0a35.44,35.44,0,0,0-9.13.78c.17-.5.33-1,.5-1.49a46.11,46.11,0,0,1,6.18-1.05s0-.07,0-.07a30,30,0,0,0-6.05.74c.85-2.52,1.77-5,2.79-7.43a44.43,44.43,0,0,1,3-5.74,36.74,36.74,0,0,1,5-.89,0,0,0,0,0,0-.08,13.22,13.22,0,0,0-4.68.46q1.23-2,2.61-3.9h0c3.51-.77,7.07-1.49,10.66-.82.06,0,.09-.09,0-.11-3.42-.9-6.82-.38-10.22.29.37-.49.75-1,1.14-1.46a23.05,23.05,0,0,1,6.56-1s.05-.07,0-.08a17.24,17.24,0,0,0-6.11.55c2.9-3.61,6.1-7,9.27-10.35C448.58,321,448.47,320.93,448.31,321.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.14,335.34a14.82,14.82,0,0,0-3.12-.11c-.12,0-.11.22,0,.22,1,0,2.06,0,3.09,0A.06.06,0,0,0,448.14,335.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.87,355.63a14,14,0,0,0-4.83,1s0,.08,0,.07c1.59-.38,3.2-.53,4.81-.8C437,355.85,437,355.63,436.87,355.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.49,348.62a10.09,10.09,0,0,0-2.05.19.06.06,0,0,0,0,.12,10,10,0,0,0,2.05-.1A.11.11,0,0,0,433.49,348.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.86,338.59a70.84,70.84,0,0,1,14.55,6.85A43.47,43.47,0,0,1,403.53,357a107.64,107.64,0,0,1,15.55,31.38,84.1,84.1,0,0,1,3.52,19.14.19.19,0,0,1-.37,0,108.55,108.55,0,0,0-9.48-32.5c-4.74-10.07-10.74-20.79-19.9-27.46-5-3.63-10.6-6-16.2-8.52C376.36,338.9,376.57,338.49,376.86,338.59Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.42,381.16a65.15,65.15,0,0,0-11.58-8.43c-6.47-3.59-11.73-6-13.34-9.1s3.39-7.21,3.39-7.21-6.6,3.23-9.34.86-8.5-19-8.5-19,15.25,5.43,24.78,16.42S415.42,381.16,415.42,381.16Z",
    style: {
      fill: "#8B5CF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.63,377.72c-7.63-14.32-17.81-27.27-31.76-35.82,0,0,0,0,0,0a70,70,0,0,1,10.2,8,16.17,16.17,0,0,0-8.2,1.73c-.05,0,0,.1.05.08a22.49,22.49,0,0,1,8.43-1.42.18.18,0,0,0,.1,0l1.47,1.43a25.87,25.87,0,0,0-4.39.58s0,.07,0,.06a22.35,22.35,0,0,1,4.62-.38,94.92,94.92,0,0,1,7.2,8.17,7.39,7.39,0,0,0-3.07.22.06.06,0,0,0,0,.12,16.25,16.25,0,0,1,3.27-.05c.42.53.84,1.06,1.25,1.6a29.5,29.5,0,0,0-9.26.9s0,.08,0,.07a37.49,37.49,0,0,1,9.51-.62c.39.52.76,1,1.14,1.57a20.11,20.11,0,0,0-5.51.63c-.07,0-.05.13,0,.11a21.42,21.42,0,0,1,5.7-.44c1.65,2.26,3.22,4.57,4.73,6.91a5.09,5.09,0,0,0-2.42.14s0,.08,0,.07a10.43,10.43,0,0,1,2.62.13c1.36,2.11,2.67,4.25,3.93,6.39C414.44,378.05,414.73,377.91,414.63,377.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.76,365.84a12.08,12.08,0,0,0-4.43.54s0,.08,0,.07a34.32,34.32,0,0,1,4.41-.45C402.85,366,402.87,365.85,402.76,365.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.46,348.39a7.83,7.83,0,0,0-2,.12c-.08,0-.05.13,0,.12.67-.07,1.33,0,2-.06A.09.09,0,0,0,389.46,348.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.1 428.51 400.67 428.51 405.57 392.55 406.83 383.33 428.93 383.33 430.19 392.55 435.1 428.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.19 392.55 405.57 392.55 406.83 383.33 428.93 383.33 430.19 392.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.67,
    y: 380.13,
    width: 28.42,
    height: 7.81,
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessCuate);
export default __webpack_public_path__ + "static/media/Process-cuate.43e539c1536a86b9498c7e9e989af46c.svg";
export { ForwardRef as ReactComponent };